import { useEffect } from 'react'
import type { PlatformConnectionStatus } from './components/PlatformConnectionScreen'

const SUCCESS_CLOSE_DELAY_MS = 1500

export default function useAutoCloseOnSuccess(status: PlatformConnectionStatus) {
  useEffect(() => {
    if (status !== 'success') return

    window.opener?.focus()
    const closeTimer = window.setTimeout(() => window.close(), SUCCESS_CLOSE_DELAY_MS)
    return () => window.clearTimeout(closeTimer)
  }, [status])
}
